import {VSubheader, VBtn} from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import VPage from '@/vuetify_custom/v-pagination'
import { publish_form_list } from '@/views/blogger/fields.js'
import { formattingNumber } from '@/libs/util'
import { getsafe } from '@/libs/util.js'
import EditModal from '@/views/blogger/records/components/editModal.jsx'
import History from '@/views/components/viewer/components/History.vue'
import DelModal from '@/views/blogger/records/components/DelModal.jsx'
import {getContractRelatedPlacingRecordsApi, getOutsourceContractRelatedPlacingRecordsApi} from '../services'
export default {
    props: {
        record: {
          type: Object,
          default: () => ({})
        },
        showAdd:{
          type: Boolean,
        },
        contractType: {
          type: String
        }
    },
    data() {
      return {
        placing_ads_records: [],
        get_data_loading:false,
        list: [],
        params: {
          id:null,
          page:null,
          per_page:null,
          search:null,
          total_count:0,
        },
        sum_price: 0,
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer || {groups:[]};
      },
      isFin() {
        return this.cur_customer.groups.includes("GROUP_FIN") 
      },
      sameGroup() {
        const current_hash = this.$store.state.hash_authority || {}
        return current_hash['tfjl_edit']
      },
        table_tf_fields() {
        
            return [
              {
                text: '投放编号',
                align: 'center',
                value: 'uid',
                width: 120,
                fixed: 'left',
                z_index: 1
              }, 
              {
                text: '投放博主',
                align: 'center',
                value: 'platform_nickname',
                width: 240,
                render: (v, t) => {
                  return <History 
                    value={t}
                    name={getsafe(t, 'kol.platform_nickname')}
                  />
                }
              }, 
              {
                text: '预计投放时间',
                align: 'center',
                value: 'estimate_publish_at',
                width: 120,
              },
              {
                text: '发布时间',
                align: 'center',
                value: 'publish_at',
                width: 120,
              },
              {
                text: '发布类型',
                align: 'center',
                value: 'publish_form',
                type: 'list_field',
                item_key: 'value',
                item_text: 'label',
                items:publish_form_list,
                width: 120,
              },
              {
                text: '发布平台',
                align: 'center',
                value: 'platform',
          
                width: 120,
                render:(_, t) => <div>{t.kol && t.kol.platform || '-'}</div>
              },
              {
                text: '对接人',
                align: 'center',
                value: 'docking_customer_name',
                width: 120,
              },
              {
                text: '项目组',
                align: 'center',
                type: 'team_field',
                value: 'team_id',
                width: 120,
              },
              {
                text: 'SKU',
                align: 'center',
                value: 'sku',
                width: 120,
                render:(_, t) => <div>{t.sku && t.sku.full_name || '-'}</div>
              },
              {
                text: '预计投放金额',
                align: 'center',
                value: 'total_price',
                type: 'money_field',
                width: 120,
              },
              {
                text: '付款进度',
                type: 'money_field',
                align: 'center',
                value: 'paid_price',
                width: 120,
              },
              {
                text: '消耗进度',
                type: 'money_field',
                align: 'center',
                value: 'consume_price',
                width: 120,
              },
              {
                text: '加成服务',
                type: 'money_field',
                align: 'center',
                value: 'vas_amount',
                width: 120,
              },
              {
                text: '返点金额',
                type: 'money_field',
                align: 'center',
                value: 'rebate_amount',
                width: 120,
              },
              // {
              //     text: '投放类型',
              //     align: 'center',
              //     value: 'placing_type',
              //     width: 120,
              //     type: 'list_field',
              //     item_key: 'value',
              //     item_text: 'label',
              //     items: put_in_types
              // },
              {
                text: '发布时间',
                align: 'center',
                value: 'publish_at',
                width: 120,
              },
              {
                text: '附件',
                align: 'center',
                value: 'bfiles',
                width: 120,
                render:(_, t) => {
                  if (!t.bfiles || !t.bfiles.length) {
                      return '-'
                  }
                  return <div>
                 <Attachments files={t.bfiles} showDetail={false}/> 
                </div>
                } 
              },
              {
                text: '操作',
                b_text: '操作',
                align: 'center',
                value: 'action',
                fixed: 'right',
                width: 100,
                type: 'button_s_field',
                z_index:2,
                callBack:({key}, target) => this.recordChange(key, target),
                buttons:(_, target) => [
                  {
                      text: '编辑',
                      key: 'edit',
                      show: this.showDT(target) || this.sameGroup()
                  },
                  {
                      text: '复制',
                      key: 'copy',
                  },
                  {
                      text: '废弃',
                      key: 'del',
                  }
              ].filter(i => {
                if (i.show === undefined) {
                  return true
                }
                return i.show
              })
              }
            ]
          },
    },
    created() {
      this.params.id = this.record.id
      this.getData()
    },
    methods: {
      showDT(target) {
        if (this.isFin || [target.director_id, target.docking_customer_id].includes(this.cur_customer.id)) {
            return true
        }
        return false 
    },
      recordChange(key, target) {
        switch (key) {
          case 'edit':
            this.$refs.editModal.edit(target)
            break;
          case 'copy':
            this.$refs.editModal.copy(target)
            break
          case 'del':
            this.$refs.del.edit(target)
            break
          default:
            break;
        }
      },
      getData(params = {}) {
        const _params = {
            ...this.params,
            ...params,
        }
        this.get_data_loading = true
        const getApi = this.contractType === 'outsource' ? getOutsourceContractRelatedPlacingRecordsApi : getContractRelatedPlacingRecordsApi
        getApi(_params).then(res => {
            this.list = res.placing_ads_records
            this.params.page = res.cur_page
            this.params.per_page = res.per_page
            this.params.total_count = res.total_count
            this.sum_price = res.sum_price
      }).finally(() => {
          this.get_data_loading = false
      })
    },
    },
    render() {
      const is_show = (this.record && this.record.contract_type && this.record.contract_type.sub_type === '广告合同') || 
      (this.record && this.record.job_content === '广告推广')
        if (!is_show) {
          
            return <div></div> 
        }
        return <div>
          <VSubheader>
             投放记录
             
              {this.showAdd && <VBtn style="margin-left:10px" small on={{
               click: () => {
                 this.$emit('addTf', this.record, () => {
                  this.params.page = 1
                  this.$nextTick(this.getData)
                 })
               }
             }}>添加投放记录</VBtn>}
          </VSubheader>
          <span style="margin:0px 10px">预计投放总金额：{formattingNumber(this.sum_price, 2)}</span>
        <VTable
          loading={this.get_data_loading}
          headers={this.table_tf_fields}
          desserts={this.list}
        />
         {!!this.params.total_count && <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                        this.params.per_page = per_page
                        this.params.page = 1
                        this.$nextTick(this.getData)
                    },
                    pageChange:(page) => {
                        this.params.page = page
                
                        this.$nextTick(this.getData)
                    }
                  }
                }
              />}
              <EditModal ref="editModal" on={{
                    success:() => {
                    
                        this.params.page = 1
                        this.$nextTick(this.getData)
                    }
                }}/>
              <DelModal
                ref="del"
                on={{
                    success:() => {
                    
                        this.params.page = 1
                        this.$nextTick(this.getData)
                    }
                }}
            />
        </div>
    }
}